var map = {
	"./1.jpg": 42,
	"./2.jpg": 81,
	"./3.jpg": 82,
	"./4.jpg": 83,
	"./5.jpg": 84,
	"./alt/1.jpg": 43,
	"./alt/2.jpg": 44,
	"./alt/3.jpg": 45,
	"./alt/4.jpg": 46,
	"./alt/5.jpg": 47
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;